import React from 'react';

function VimeoIcon(props: React.ComponentProps<'svg'>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            {...props}>
            <path d="M21.977 7.00971C21.8898 8.95776 20.5306 11.6265 17.8993 15.016C15.1775 18.5544 12.875 20.3236 10.992 20.3236C9.818 20.3236 8.84398 19.2454 8.0316 17.0899L6.43434 11.1616C5.83498 9.00914 5.19286 7.93235 4.50796 7.93124C3.94162 8.16611 3.41341 8.48399 2.94069 8.87443L2 7.66212C2.97874 6.79947 3.95082 5.93015 4.91623 5.05417C6.23214 3.91434 7.2195 3.31471 7.87829 3.25528C9.43361 3.1053 10.391 4.17125 10.7504 6.45313C11.1392 8.91387 11.4089 10.4434 11.5594 11.0416C12.0082 13.083 12.5015 14.1034 13.0392 14.1028C13.4575 14.1028 14.0865 13.4404 14.9264 12.1156C15.5848 11.2154 16.0428 10.1847 16.2695 9.09274C16.3895 7.95041 15.9362 7.37549 14.9247 7.37549C14.4138 7.37858 13.9092 7.4896 13.4441 7.70128C14.4323 4.47843 16.3054 2.90449 19.0808 3.00448C21.1413 3.05447 22.1037 4.39094 21.9912 7.00388L21.977 7.00971Z" />
        </svg>
    );
}

export default VimeoIcon;